import { render, staticRenderFns } from "./GStoryImageDescriptionForm.vue?vue&type=template&id=02c76d6a&scoped=true&"
import script from "./GStoryImageDescriptionForm.vue?vue&type=script&lang=ts&"
export * from "./GStoryImageDescriptionForm.vue?vue&type=script&lang=ts&"
import style0 from "./GStoryImageDescriptionForm.vue?vue&type=style&index=0&id=02c76d6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c76d6a",
  null
  
)

export default component.exports